export default import.meta.ROLLDOWN_FILE_URL_FjZoJMxaNBfr5eOkud6aIw